import React from 'react'
import ReactQuill from 'react-quill'
import axios from 'axios'
import Swal from 'sweetalert2'
import Constant from '../../../Constant'

class ChaletPolicyAdd extends React.Component {
  state = {
    pageTitle: 'Chalet Policy',
    chalet_policy_en: '',
    chalet_policy_ar: '',

    isSaving: false,
  }

  componentDidMount() {
    this.loadPolicy()
  }

  loadPolicy = async () => {
    await axios
      .get(Constant.getAPI() + `/client/get-client-settings/chalet-policy`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState(res.data.data)
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (value, lang) => {
    if (lang == 'en') {
      this.setState({ chalet_policy_en: value })
    } else {
      this.setState({ chalet_policy_ar: value })
    }
  }

  onSave = () => {
    this.setState({ isSaving: true })

    var data = {
      id: this.state.id,
      chalet_policy_en: this.state.chalet_policy_en,
      chalet_policy_ar: this.state.chalet_policy_ar,
    }

    axios
      .post(Constant.getAPI() + '/client/update-client-settings', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isSaving: false })

        if (res.status) {
          Swal.fire({
            title: 'Policy Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .catch((err) => {
        this.setState({ isSaving: false })

        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>{this.state.pageTitle}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-12 col-form-label">English</label>
                          <div className="col-sm-12">
                            <ReactQuill
                              value={this.state.chalet_policy_en}
                              onChange={(value) => this.handleChange(value, 'en')}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-12 col-form-label">Arabic</label>
                          <div className="col-sm-12">
                            <ReactQuill
                              value={this.state.chalet_policy_ar}
                              onChange={(value) => this.handleChange(value, 'ar')}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="row float-right p-3">
                      {this.state.isSaving ? (
                        <button
                          className="btn btn-grd-disabled mr-2"
                          disabled
                        >
                          Saving...!
                        </button>
                      ) : (
                        <button
                          onClick={this.onSave}
                          className="btn btn-grd-disabled mr-2"
                        >
                          <i className="icofont icofont-save"></i> Save{' '}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ChaletPolicyAdd
